// biome-ignore lint/suspicious/noShadowRestrictedNames: <This is a lodash util, it's fine>
import { isFinite } from 'lodash';
import pluralize from 'pluralize';

export const formatEstimatedCompletionTime = (
  estimatedCompletionTime: number | null,
): { formattedCompletionTime: string | null; showSpeed: boolean } => {
  if (!estimatedCompletionTime) {
    return { formattedCompletionTime: null, showSpeed: false };
  }

  if (!isFinite(estimatedCompletionTime)) {
    return { formattedCompletionTime: 'Starting', showSpeed: false };
  }

  const seconds = estimatedCompletionTime / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  const days = hours / 24;

  let remainingTime = '';

  if (days >= 1) {
    remainingTime = `${pluralize('day', Math.floor(days), true)}`;

    const remainingHours = hours % 24;

    if (remainingHours) {
      remainingTime += ` ${Math.floor(remainingHours)} hr`;
    }
  } else if (hours >= 1) {
    remainingTime = `${Math.floor(hours)} hr`;

    const remainingMinutes = minutes % 60;

    if (remainingMinutes) {
      remainingTime += ` ${Math.floor(remainingMinutes)} min`;
    }
  } else if (minutes >= 1) {
    remainingTime = `${Math.floor(minutes)} min`;

    const remainingSeconds = seconds % 60;

    if (remainingSeconds) {
      remainingTime += ` ${Math.floor(remainingSeconds)}s`;
    }
  } else {
    if (Math.floor(seconds) <= 0) {
      return { formattedCompletionTime: 'Finishing up...', showSpeed: false };
    } else {
      remainingTime = `${Math.floor(seconds)}s`;
    }
  }

  return { formattedCompletionTime: remainingTime, showSpeed: true };
};
